import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const SegmentTemplatesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/segment-templates" */
    'routes/Control/Segments/TemplatesRoute'
  )
));

const UpdateSegmentRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/update-segment" */
    'routes/Contacts/UpdateSegmentRoute'
  )
));


const getControlSegmentsRoutes = () => {
  return [
    {path: paths.getPathControlSegmentTemplates(), component: SegmentTemplatesRoute},
    {path: paths.getPathControlAddSegmentTemplate(), render: (props) => <UpdateSegmentRoute {...props} isTemplate={true} />},
    {path: paths.getPathControlEditSegmentTemplate(":templateId"), render: (props) => <UpdateSegmentRoute {...props} isTemplate={true} />},

  ]
}



export { getControlSegmentsRoutes };
